import types from './types';
import { t } from 'i18next';

const Messages = action => {
  switch (action.type) {
    case types.START_FAILURE:
      return {
        title: t('message.title.error.start.app'),
        message: t(action.data.message),
        type: 'error'
      };
    default:
      return false;
  }
};

export default Messages;
